import React from 'react';
import { TimePicker } from 'react-datepickers';

import withTranslatePlaceholder from 'components/hocs/withTranslatePlaceholder';
import withFieldWrapper from 'components/hocs/withFieldWrapper';

const LocalizedTimepicker = withTranslatePlaceholder(TimePicker);

const TimepickerComponent = ({ input, min, max, allowClear }) => (
    <LocalizedTimepicker
        input={input}
        min={min}
        max={max}
        placeholder="placeholders.timepicker"
        allowClear={allowClear}
    />
);

export default withFieldWrapper(TimepickerComponent);
